import type { ITourPoi, ITourTranslation } from '@/shared/api/types/tour-types'

export interface TourBasicInfoDraftState {
  duration: number
  scopeType: 'province' | 'tenantDestination'
  countryId: string
  provinceId: string
  tenantDestinationId: string
  ticketLink: string
  isFavorite: boolean
}

export type TourDraftRouteCoordinate = [number, number]

export interface PersistedTourDraft {
  basicInfo: TourBasicInfoDraftState
  translations: ITourTranslation[]
  selectedPois: ITourPoi[]
  routeCoordinates: TourDraftRouteCoordinate[]
  thumbnail?: string
  banner?: string
}

export interface BuildTourDraftInput {
  basicInfo: TourBasicInfoDraftState
  translations: ITourTranslation[]
  selectedPois: ITourPoi[]
  routeCoordinates: TourDraftRouteCoordinate[]
  thumbnail?: string | undefined
  banner?: string | undefined
}

export function buildTourDraft(input: BuildTourDraftInput): PersistedTourDraft {
  return {
    basicInfo: input.basicInfo,
    translations: input.translations,
    selectedPois: input.selectedPois,
    routeCoordinates: input.routeCoordinates,
    ...(input.thumbnail ? { thumbnail: input.thumbnail } : {}),
    ...(input.banner ? { banner: input.banner } : {}),
  }
}

export function hasTourDraftContent(
  input: BuildTourDraftInput,
  defaultBasicInfo: TourBasicInfoDraftState,
): boolean {
  const basicInfoChanged =
    input.basicInfo.duration !== defaultBasicInfo.duration ||
    input.basicInfo.scopeType !== defaultBasicInfo.scopeType ||
    input.basicInfo.countryId !== defaultBasicInfo.countryId ||
    input.basicInfo.provinceId !== defaultBasicInfo.provinceId ||
    input.basicInfo.tenantDestinationId !== defaultBasicInfo.tenantDestinationId ||
    input.basicInfo.ticketLink.trim() !== defaultBasicInfo.ticketLink.trim() ||
    input.basicInfo.isFavorite !== defaultBasicInfo.isFavorite
  const hasTranslationContent = input.translations.some(
    (row) => row.name.trim() || row.description.trim(),
  )
  return (
    basicInfoChanged ||
    hasTranslationContent ||
    input.selectedPois.length > 0 ||
    input.routeCoordinates.length > 0 ||
    Boolean(input.thumbnail?.trim()) ||
    Boolean(input.banner?.trim())
  )
}
